import _ from "lodash";

export function findByInquiryId (jobProfile, inquiryId)
{
	let group = null;

	_.forEach(jobProfile.areas || [], area =>
	{
		_.forEach(area.groups || [], areaGroup =>
		{
			if (areaGroup.inquiry && areaGroup.inquiry.id === inquiryId)
			{
				group = areaGroup;

				return false; // break
			}
		});
	});

	return group;
}